import { render } from "./owned-affiliates-submissions.view.vue?vue&type=template&id=ee2a49ae&scoped=true&ts=true"
import script from "./owned-affiliates-submissions.view.vue?vue&type=script&lang=ts"
export * from "./owned-affiliates-submissions.view.vue?vue&type=script&lang=ts"

import "./owned-affiliates-submissions.view.vue?vue&type=style&index=0&id=ee2a49ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee2a49ae"]])

export default __exports__